import { sortBy } from 'lodash'
import { useWageringTable } from '@/views/bonus-engine/hooks'
import { WageringCategory } from '@/state/wagering-contribution/models'

import SkeletonLoader from '@/views/components/skeleton'
import { TableGenericComponent } from '@/views/components'
import { WageringContributionForm, WageringRowComponent } from './'

export const WageringTableComponent = () => {
  const {
    handleDeleteWagering,
    handleEditWagering,
    wageringCategory,
    headCells,
  } = useWageringTable()

  const sortedRows = sortBy(wageringCategory, 'Name')

  const body = sortedRows.map((row: WageringCategory) => {
    return (
      <WageringRowComponent
        row={row}
        key={`wagering-category-id-${row.id}`}
        handleDeleteWagering={handleDeleteWagering}
        handleEditWagering={handleEditWagering}
      />
    )
  })

  return (
    <>
      <TableGenericComponent<WageringCategory>
        headCells={headCells}
        rowLength={sortedRows.length}
        isLoading={false}
        body={body}
        hasAction={true}
      />
      {wageringCategory.length === 0 && (
        <SkeletonLoader element="small-table" />
      )}
      <WageringContributionForm />
    </>
  )
}
